module.exports = __webpack_public_path__ + "img/shenfenzheng.cff5b4a2.jpg";